module.exports = __webpack_public_path__ + "src/assets/img/animal-farm.2509fc27.png";